
import { useDataEngine } from '@dhis2/app-runtime';
import { useEffect, useState } from 'react';

// useObjectiveWeight.js
export const useObjectiveWeight = (positionTei) => {
  const engine = useDataEngine();
  const [totalWeight, setTotalWeight] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTotalWeight = async () => {
      // ✅ If no positionTei, return 0
      if (!positionTei) {
        setTotalWeight(0);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await engine.query({
          objectives: {
            resource: 'events',
            params: {
              program: 'yiT00XKrrHP',
              programStage: 'VIBtpvkpHFR',
              filter: `SlgO60cMK3F:eq:${positionTei}`, // 🔑 Critical
              fields: 'dataValues[dataElement,value]',
            },
          },
        });

        const events = response.objectives?.events || [];
        let total = 0;
        for (const event of events) {
          const weightDV = event.dataValues?.find(dv => dv.dataElement === 'yfb9RCRpMB2');
          const weight = parseFloat(weightDV?.value);
          if (!isNaN(weight)) total += weight;
        }

        setTotalWeight(total);
      } catch (err) {
        console.error('Failed to load objective weight:', err);
        setTotalWeight(0);
      } finally {
        setLoading(false);
      }
    };

    loadTotalWeight();
  }, [positionTei, engine]);

  return { totalWeight, loading };
};